export default {
  // list
  'order_cargo.column.cargoNo': '货物编号',
  'order_cargo.column.orderId': '货单',
  'order_cargo.column.orderType': '订单类型(集装箱、件杂货、拖车)',
  'order_cargo.column.cargoTypeId': '货物类型',
  'order_cargo.column.cargoTypeName': '货物类型',
  'order_cargo.column.cargoSpecId': '货物规格',
  'order_cargo.column.cargoSpecName': '规格',
  'order_cargo.column.cargoAttrName': '货物名称',
  'order_cargo.column.cargoQty': '数量',
  'order_cargo.column.cargoWeight': '吨位',
  'order_cargo.column.loadingPoint': '起始地',
  'order_cargo.column.unloadingPoint': '目的地',
  'order_cargo.column.cargoSource': '货物来源（手动添加、库存）',
  'order_cargo.column.entryQty': '已入库数量',
  'order_cargo.column.entryWeight': '已入库吨位',
  'order_cargo.column.createBy': '创建人',
  'order_cargo.column.updateBy': '更新人',
  'order_cargo.column.createTime': '创建时间',
  'order_cargo.column.updateTime': '更新时间',
  'order_cargo.column.dataSource': '数据来源',
  'order_cargo.column.remark': '备注',
  'order_cargo.column.status': '状态',
  // edit
  'order_cargo.edit.title': '编辑托单货物信息',
  'order_cargo.add.title': '新增托单货物信息',
  'order_cargo.edit.success': '编辑成功',
  'order_cargo.add.success': '新增成功',
  'order_cargo.form.cargoTypeId.required': '货物类型ID不能为空',
  'order_cargo.form.cargoSpecId.required': '货物规格ID不能为空',
  'order_cargo.form.cargoSpecName.required': '规格不能为空',
  'order_cargo.form.cargoQty.required': '数量不能为空',
  'order_cargo.form.cargoTypeId': '货物类型',
  'order_cargo.form.cargoTypeId.placeholder': '请输入货物类型',
  'order_cargo.form.cargoSpecId': '货物规格',
  'order_cargo.form.cargoSpecId.placeholder': '请输入货物规格',
  'order_cargo.form.cargoSpecName': '规格',
  'order_cargo.form.cargoSpecName.placeholder': '请输入规格',
  'order_cargo.form.cargoAttrName': '货物名称',
  'order_cargo.form.cargoAttrName.placeholder': '货物名称',
  'order_cargo.form.cargoQty': '数量',
  'order_cargo.form.cargoQty.placeholder': '请输入数量',
  'order_cargo.form.loadingPoint': '起始地',
  'order_cargo.form.loadingPoint.placeholder': '请输入起始地',
  'order_cargo.form.unloadingPoint': '目的地',
  'order_cargo.form.unloadingPoint.placeholder': '请输入目的地',
  'order_cargo.form.remark': '备注',
  'order_cargo.form.remark.placeholder': '请输入备注',
}
